import { useState } from "react";

/**
 * A YouTube video as its thumbnail (served from this site) until it is
 * clicked; only then the no-cookie player loads, playing. The player's own
 * script logs Chromium warnings on load ("No available adapters.") whatever
 * the embed's parameters, and it is the page's heaviest part, so the home
 * page loads neither.
 */
export default function VideoFacade({ id, title }: { id: string; title: string }) {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <iframe
        // The button that had focus is gone; the player takes it.
        ref={(frame) => frame?.focus()}
        className="video"
        src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`}
        title={title}
        allow="autoplay; encrypted-media; picture-in-picture"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    );
  }
  return (
    <button type="button" className="video video-facade" onClick={() => setPlaying(true)} aria-label={`Play ${title}`}>
      <img src={`/images/video-${id}.jpg`} alt="" loading="lazy" width={960} height={540} />
      <svg className="video-play" viewBox="0 0 68 48" aria-hidden="true">
        <rect width="68" height="48" rx="12" />
        <path d="M27 14v20l18-10z" />
      </svg>
    </button>
  );
}
